import { apiService } from './api';
import {
  Collection,
  CreateCollectionDTO,
  UpdateCollectionDTO,
  GenerateCollectionDTO,
  GetCollectionsResponse,
  GetCollectionResponse
} from '../types/collection';

class CollectionsApiService {
  async getCollections(userId?: string): Promise<GetCollectionsResponse> {
    const response = await apiService.getCollections(userId);
    return response;
  }

  async getSystemCollections(): Promise<GetCollectionsResponse> {
    const response = await apiService.getSystemCollections();
    return response;
  }

  async getCollection(id: string): Promise<GetCollectionResponse> {
    const response = await apiService.getCollection(id);
    return response;
  }

  async createCollection(data: CreateCollectionDTO): Promise<Collection> {
    const response = await apiService.createCollection(data);
    return response;
  }

  async updateCollection(id: string, data: UpdateCollectionDTO): Promise<Collection> {
    const response = await apiService.updateCollection(id, data);
    return response;
  }

  async deleteCollection(id: string): Promise<void> {
    await apiService.deleteCollection(id);
  }

  async addProblemToCollection(collectionId: string, problemId: string): Promise<void> {
    await apiService.updateCollectionProblems(collectionId, 'add', [problemId]);
  }

  async removeProblemFromCollection(collectionId: string, problemId: string): Promise<void> {
    await apiService.updateCollectionProblems(collectionId, 'remove', [problemId]);
  }

  async updateCollectionOrder(userId: string, order: Record<string, number>): Promise<void> {
    await apiService.updateUserCollectionOrder(userId, order);
  }

  async updateProblemSequence(collectionId: string, problemSequence: string[]): Promise<Collection> {
    const response = await apiService.updateProblemSequence(collectionId, problemSequence);
    return response;
  }

  async generateCollectionByAI(data: GenerateCollectionDTO): Promise<Collection> {
    const response = await apiService.generateCollectionByAI(data);
    return response;
  }
}

export const collectionsApi = new CollectionsApiService();